import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function useMapValidation(menuItem: any) {
    const navigate = useNavigate();

    useEffect(() => {
        const { mapLayer } = menuItem ?? {};
        if (!mapLayer) navigate("/app/error");
    }, [menuItem, navigate]);
}
